import React from 'react';
import { Modal, Button } from 'react-bootstrap';

export const TelaModalLivre = ({handleCloseModal, titulo, children, show, btoFechar}) => {
    return (
        <Modal show={show} onHide={handleCloseModal} animation={false} backdrop="static">
            <Modal.Dialog>
                <Modal.Header closeButton={false}>
                    <Modal.Title>{titulo}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {children}
                </Modal.Body>
                {btoFechar!==false?
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>Fechar</Button>                
                </Modal.Footer>
                :
                null
                }
            </Modal.Dialog>
        </Modal>
    )
}